export default __webpack_public_path__ + "static/fv-black-text-pattern-pc-3a84f1036601700765e58569f8d33145.avif";